import React from 'react';
import './ItemCatg.css'
import { FaHandPointRight } from "react-icons/fa6";

const ItemCatg = () => {
    return (
        <div>
            <p className='itemCtgTitle'>দেশি এগ্রো ফুডস নিয়ে এসেছে ১০০% বিশুদ্ধ ও কেমিক্যালমুক্ত মসলা। সরাসরি বাছাইকৃত কাঁচামাল থেকে প্রস্তুত, স্বাস্থ্যসম্মত প্যাকেজিং সহ।</p>
            <p className='itemctgdoted'></p>
            <p className='itemctgsecondtitle'> আমাদের মসলা গুঁড়া গুলো হলো -</p>
            <div className='itemContiner'>
                <div className='itemcatgChild'>
                    <FaHandPointRight className='itemrighthand' /> <p>লাল মরিচের গুঁড়া</p>
                </div>
                <div className='itemcatgChild'>
                    <FaHandPointRight className='itemrighthand' /> <p>হলুদের গুঁড়া</p>
                </div>
                <div className='itemcatgChild'>
                    <FaHandPointRight className='itemrighthand' /> <p>ধনিয়ার গুঁড়া</p>
                </div>
                <div className='itemcatgChild'>
                    <FaHandPointRight className='itemrighthand' /> <p>জিরার গুঁড়া</p>
                </div>

            </div>
            <p style={{ fontWeight: '600', fontSize: '20px', fontFamily: 'tiro bangla' }}>আপনি আপনার পরিমাণমত মসলা গুঁড়া নিতে পারবেন । </p>
        </div>
    );
};

export default ItemCatg;